export default __webpack_public_path__ + "static/media/Invitation invalid-2.c33308b4.png";